import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import UsersHelper, { userError } from '../../helpers/UsersHelper';
import PasswordFields, { passwordError } from './PasswordFields';

export default function ChangePassword() {
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  async function submit(e) {
    e.preventDefault();
    const validation = passwordError(newPassword, confirmation);
    if (validation) return setError(validation);
    setBusy(true); setError('');
    try {
      await UsersHelper.changePassword({ currentPassword, newPassword });
      localStorage.removeItem('token');
      setCurrent(''); setPassword(''); setConfirmation(''); setDone(true);
    } catch (err) { setError(userError(err)); }
    finally { setBusy(false); }
  }
  return <section className="section"><div className="container" style={{ maxWidth: 560 }}>
    <h1 className="title">Change password</h1>
    {done ? <div className="notification is-success" role="status">Your password was changed. Your existing sessions have been signed out. <Link to="/login">Sign in again</Link>.</div> :
      <form onSubmit={submit}>
        <p className="block">Enter your current password to choose a new one. You will need to sign in again afterward.</p>
        {error && <p className="notification is-danger" role="alert">{error}</p>}
        <fieldset disabled={busy} style={{ border: 0, padding: 0 }}>
          <div className="field"><label className="label" htmlFor="current-password">Current password</label>
            <input className="input" id="current-password" type="password" autoComplete="current-password" required
              value={currentPassword} onChange={e => setCurrent(e.target.value)} /></div>
          <PasswordFields password={newPassword} confirmation={confirmation} onPassword={setPassword} onConfirmation={setConfirmation} />
          <button className={`button is-primary ${busy ? 'is-loading' : ''}`} type="submit">Change password</button>
        </fieldset>
      </form>}
  </div></section>;
}
